// src/blogs/postScenes/index.js
// Registry of 3D post-theme backdrops, keyed by the id a post's
// `theme.scene` field names (see the shape note atop blogData.js). Lazy —
// most posts won't use a 3D backdrop, so there's no reason to bundle every
// scene into the main chunk. Consumed by PostThemeBackdrop.jsx.
import { lazy } from "react";

export const POST_SCENES = {
  // Stand-in, registered purely to prove the mechanism works end-to-end —
  // swap in real per-theme scenes (e.g. a grassy field) as they're designed,
  // and remove this once nothing references it.
  placeholder: lazy(() => import("./PlaceholderPostScene.jsx")),

  // The Thoughts blog's own backdrop (set as ThoughtsBlog's `defaultTheme`,
  // not on individual posts): drifting, colliding pastel cubes.
  thoughtsCubes: lazy(() => import("./ThoughtsCubesScene.jsx")),

  // Holographic foil cloth with the post's text printed on it — set on a
  // single post's theme (with hideText: true). See HoloClothScene.jsx.
  holoCloth: lazy(() => import("./HoloClothScene.jsx")),
};
